import _ from "lodash";

import { ProposalWithOwner } from "@/utils/types";

import { ProposalValue } from "./types";

export function getSuggestion(proposalValue: ProposalValue) {
  return proposalValue.overrideValue ?? proposalValue.logicComputedValue ?? null;
}

export function getNote(proposalValue: ProposalValue): string[] | null {
  if (proposalValue?.overrideNote) {
    return [proposalValue.overrideNote];
  }

  return proposalValue?.computedNote ?? null;
}

export function getProposalCurrencyCode(proposal: ProposalWithOwner) {
  return proposal.owner.salaryCurrencyCode;
}

export function isValidProposedNumberValue(value: number | null) {
  return _.isNumber(value) && !_.isNaN(value);
}
